import React, { useEffect, useState } from "react";
import { Link,useNavigate, useOutletContext } from "react-router-dom";
import GameSvcCtntCtxtApi from "Apis/GameSvcCtntCtxtApi";
import TrmsLstInqApi from "Apis/TrmsLstInqApi";
import sanitizeHtml from 'sanitize-html';
import MgpStore from "Stores/Store";
import CtntCategoryMenu from "Components/CtntCategoryMenu";
import GamePageBanner from "Components/GamePageBanner";

import "Assets/css/Trms.css";
import "Assets/css/Ctnt.css";
import { useLocation } from "react-router-dom";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import ApiResultModal from "Components/ApiResultModal";

const GameCtntCtxtUi = ({gameSvcCd,ctntKindCd,ctntPstdSno}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const navigate = useNavigate();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    const test =() => {
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getCtntKindCd = query.get("ctntKindCd");
    let getctntPstdSno = query.get("ctntSno");
    let getPageState = query.get("pageState");
    if(getGameSvcCd !=null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getCtntKindCd;
        ctntPstdSno = getctntPstdSno;
    }

    if(gameSvcCd ==null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd ==null) {
        ctntKindCd = location.state?.ctntKindCd;
    }

    const [ctntKindCdState,setctntKindCdState] = useState(getCtntKindCd);
    const [ctntPstdCtxtState,setctntPstdCtxtState] = useState<any>();
    const [ctntPstdTitlState,setctntPstdTitlState] = useState<any>();
    const [aplyStrtDtimeState,setAplyStrtDtimeState] = useState<any>();
    const [ctntTitlState,setCtntTitlState] = useState("");
    const [vwrCntState,setVwrCntState] = useState<any>();
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);

    // 동적 메뉴 데이터 - API에서 받은 menu 구조에서 특정 menuCd의 subMenuLst 추출
    const targetMenuCd = "NEWS"; // 필요한 menuCd로 변경
    const targetMenu = gameMainPageData?.menu?.find((menu: any) => menu.menuCd === targetMenuCd);
    
    const ctntMenuData = targetMenu?.subMenuLst?.map((subMenu: any) => {
        // URL에서 ctntKindCd 파라미터 추출
        const urlParams = new URLSearchParams(subMenu.url?.split('?')[1] || '');
        const ctntKindCd = urlParams.get('ctntKindCd') || subMenu.menuCd;
        
        return {
            Link: subMenu.url || '#',
            Txt: subMenu.menuNm,
            Display: subMenu.useYn,
            Code: ctntKindCd, // URL에서 추출한 ctntKindCd 사용
            BlankYn: subMenu.blankYn
        };
    }) || [];
    
    // 표시되는 메뉴만 필터링
    const visibleMenus = ctntMenuData.filter((menu: any) => menu.Display === "Y");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null); 
    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };
    let test1:any;
    useEffect(()=>{
        if (!langData) return;
        GameSvcCtntCtxtApi(getGameSvcCd,getctntPstdSno)
        .then((Resp) => {
            if(Resp.apiHdr.code !="GAME0000") {
                openResultModal(`${Resp.apiHdr.msg}`,() => {
                    navigate(`/GamePage/Ctnt/CtntLst?gameSvcCd=BBO&ctntKindCd=${getCtntKindCd}`);
                });
            }
            setctntPstdTitlState(Resp.apiBody.ctntTitl);
            setAplyStrtDtimeState(Resp.apiBody.aplyStrtDtime);
            setVwrCntState(Resp.apiBody.vwrCnt);
            // const dirty = Resp.apiBody.ctntPstdCtxt;
            // test1 = sanitizeHtml(dirty,{});
            setctntPstdCtxtState(Resp.apiBody.ctntCtxt);
            switch(ctntKindCdState){
                case "PNOT":
                    setCtntTitlState(langData?.GAME_SVC_PNOT_LST_TITL_00);
                break;
                case "UPDT":
                    setCtntTitlState(langData?.GAME_SVC_UPDT_LST_TITL_00);
                break;
                case "EVNT":
                    setCtntTitlState(langData?.GAME_SVC_EVNT_LST_TITL_00);
                break;
                case "DVNT":
                    setCtntTitlState(langData?.GAME_SVC_DVNT_PAGE_TITL_00);
                break;
            }
        })
    },[MgpStore.getState().LangSetState.Lang, langData]);

    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);
   const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
   
    return(
        <>
        <ApiResultModal
                    open={resultModalOpen}
                    message={resultModalMessage}
                    onClose={closeResultModal}
        confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                />
        <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} />
            <div className="container1580 mt30">
                <button
                    className="mobileCategoryBtn"
                    onClick={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                >
                    <span>{visibleMenus.find((m:any)=>m.Code===ctntKindCdState)?.Txt || '카테고리'}</span>
                    <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
                </button>
                <h1 className="ctntCtgrTitlTxt">
                    <a href="/GamePage/Ctnt/CtntLst?gameSvcCd=BBO&ctntKindCd=PNOT" className="ctntCtgrTitlTxtLink">
                        NEWS
                    </a>
                </h1>
                <div className="ctntLstWrap ctntPstdLstWrap faqLstContentsWrap">
                    <div className="faqLst">

                        {isMobileCategoryOpen && (
                            <div className="mobileMenuOverlay" onClick={() => setIsMobileCategoryOpen(false)} />
                        )}

                        <CtntCategoryMenu
                            menus={visibleMenus}
                            activeCode={ctntKindCdState || ''}
                            className={`faqCtgrLstWrap ${isMobileCategoryOpen ? 'mobileOpen' : ''}`}
                            onSelect={(code: string) => {
                                setIsMobileCategoryOpen(false);
                                const menu = visibleMenus.find((m: any) => m.Code === code);
                                if (menu) navigate(menu.Link);
                            }}
                        />

                        <div className="faqCtxtLstWrap">
                            <div className="trmsContainer">
                                <div className="ctntCtgr">
                                    <h1 className="ctntCtgrTitl">{ctntTitlState&&ctntTitlState}</h1>
                                </div>
                                <div className="trmsCtxtWrap">
                                    <div className="ctntTitlWrap">
                                        <h1>{ctntPstdTitlState}</h1>
                                        <div className="dFlex gap10 alignCenter">
                                            <p>{aplyStrtDtimeState}</p>
                                            <p className="vwrCnt"><i className="eye"></i>{vwrCntState}</p>
                                        </div>
                                    </div>
                                    {ctntPstdCtxtState != null?
                                        <div className="trmsCtxt ctntCtxt gamePageCtntCtxt" 
                                            dangerouslySetInnerHTML={{ __html: ctntPstdCtxtState }}
                    
                                        />
                                    : null}
                                </div>
                                <div className="ctntBtnWrap">
                                    <Link to={location.state?.returnUrl || `/GamePage/Ctnt/CtntLst?gameSvcCd=${getGameSvcCd}&ctntKindCd=${getCtntKindCd}&lang=${MgpStore.getState().LangSetState.Lang}&page=1`}>
                                        <p>{langData&&langData.GAME_SVC_COMM_LST_BTN_00}</p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default GameCtntCtxtUi;
